<template>
  <show-goods-table :goods-list="goods_list" class="goods-show-list">
        <template>
            <el-table-column label="商品规格">
                <template slot-scope="scope">
                    {{scope.row.specifications.name}}
                </template>
            </el-table-column>
            <el-table-column label="是否给购买者发放奖券">
              <template slot-scope="scope">
                {{scope.row.buyerTicketsReward?'是':"否"}}
              </template>
            </el-table-column>
            <el-table-column label="是否给分享者发放奖券">
              <template slot-scope="scope">
                {{scope.row.sharerTicketsReward?'是':"否"}}
              </template>
            </el-table-column>
            <el-table-column label="抽奖券">
              <template slot-scope="scope">
                {{scope.row.actTicketsName}}
              </template>
            </el-table-column>
        </template>
  </show-goods-table>
</template>
<script>
import showGoodsTable from '../../pt-promotion-coupon/show-goods-table'
export default {
  components: {
    showGoodsTable
  },
  props: {
    goodsList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      goods_list: JSON.parse(JSON.stringify(this.goodsList))
    }
  },
  watch: {
  }
}
</script>
<style lang="less">

</style>
